import React, { useState, useEffect, useRef } from "react";
import { FormGroup, Label, Input, Button } from "reactstrap";
import "../../assets/css/textField.css";

export const EmailTagsInput = ({
  state,
  setState,
  label = "Emails com Cópia",
  id = "emailsCC",
}) => {
  const [inputValue, setInputValue] = useState("");
  const [emails, setEmails] = useState([]);
  const [focused, setFocused] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    setEmails(state.emailsCC || []);
  }, [state.emailsCC]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      const newEmail = inputValue.trim();

      if (newEmail && validateEmail(newEmail) && !emails.includes(newEmail)) {
        const updated = [...emails, newEmail];
        setEmails(updated);
        setState((prev) => ({ ...prev, emailsCC: updated }));
      }

      setInputValue("");
    }
  };

  const removeEmail = (index) => {
    const updated = emails.filter((_, i) => i !== index);
    setEmails(updated);
    setState((prev) => ({ ...prev, emailsCC: updated }));
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const handleClickLabel = () => {
    if (inputRef.current) inputRef.current.focus();
  };

  return (
    <FormGroup className="textField text-left left-inner-addon">
      <div
        className="d-flex align-items-center flex-wrap form-control gap-1"
        style={{ minHeight: "46px" }}
      >
        {emails.map((email, index) => (
          <span
            key={index}
            className="badge bg-secondary text-white d-flex align-items-center gap-2 mr-2 mb-1"
            style={{ padding: "10px" }}
          >
            {email}
            <Button
              color="danger"
              onClick={() => removeEmail(index)}
              size="sm"
              className="ml-2 py-0 px-2"
              style={{ lineHeight: "1", fontSize: "0.8rem" }}
            >
              &times;
            </Button>
          </span>
        ))}

        <Input
          innerRef={inputRef}
          id={id}
          type="text"
          className="border-0 flex-grow-1"
          value={inputValue}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          style={{ minWidth: "200px", outline: "none", boxShadow: "none" }}
        />
      </div>

      <Label
        onClick={handleClickLabel}
        for={id}
        className={`label ${
          focused || emails.length > 0 || inputValue !== ""
            ? "label-active"
            : ""
        }`}
      >
        {label}
      </Label>
    </FormGroup>
  );
};
